import { combineReducers } from 'redux';
import apersonal from './apersonal';
import auth from './auth';
import client from './client';
import home from './home';
import options from './options';
import payment from './payment';
import pyme from './pyme';
import quotation from './quotation';
import health from './health';
import rental from './rental';
import steps from './steps';
import vehicles from './vehicles';
import yates from './yates';

const storeReducer = combineReducers({
  apersonal,
  auth,
  client,
  home,
  options,
  payment,
  pyme,
  quotation,
  health,
  rental,
  steps,
  vehicles,
  yates,
});

export default storeReducer;